interface StringMap {
    [key: string]: string;
}

/**
 * A mapping of satchel action names to corresponding workflow names.
 */
let actionToSignalMapping: StringMap = {};

/**
 * Adds multiple action-to-signal mapping entries
 * @param mappings An action-to-signal mapping object
 */
export const registerWorkflowActions = (mappings: StringMap): void => {
    actionToSignalMapping = { ...actionToSignalMapping, ...mappings };
};

/**
 * Deletes entry from the mapping object by action name
 * @param actionName Name of the satchel action
 */
export const removeMappingByActionName = (actionName: string): boolean =>
    delete actionToSignalMapping[actionName];

/**
 * Returns workflow signal name for the specified action name
 * @param actionName Name of the satchel action
 */
export const getSignalNameFromActionName = (actionName: string): string | undefined =>
    actionToSignalMapping[actionName];

/**
 * Tells if the satchel action is to be tracked as a workflow event or not.
 * @param actionName Name of the satchel action
 */
export const isActionToBeTracked = (actionName: string): boolean =>
    !!getSignalNameFromActionName(actionName);
